function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["identifications"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/**
 * @class Oskari.catalogue.bundle.metadataflyout.view.MetadataPage
 *
 *
 * This hosts metadata content loaded via ajax from
 * Geonetwork
 *
 * Embeds  metadata information.
 *
 */
Oskari.clazz.define('Oskari.catalogue.bundle.metadataflyout.view.MetadataPage',
/**
 * @method create called automatically on construction
 * @static
 *
 */
function (instance, locale) {
  /* @property instance bundle instance */
  this.instance = instance;

  /* @property locale locale for this */
  this.locale = locale;
  // We need lancode localizations...
  locale.languages = Oskari.getLocalization('DivManazer').LanguageSelect.languages;
  this.asyncTabs = {};
}, {
  init: function init() {},
  /**
   * @private @method _createContent
   * Creates actual tab content from fetched metadata and templates
   *
   * @param {Object} data
   *
   */
  _createContent: function _createContent(data) {
    var me = this;
    if (data === null || data === undefined) {
      throw new TypeError('_createContent(): missing data.');
    }
    var identifications = data.identifications,
      template = _objectWithoutProperties(data, _excluded);
    if (identifications.length === 0) {
      //  No identifications, show metadata not found message
      me._showMetadataNotFoundMessage();
    } else {
      // Create a panel for each identification
      for (var i = 0; i < identifications.length; i += 1) {
        var identification = identifications[i];
        var model = _objectSpread(_objectSpread({}, template), {}, {
          identification: identification
        });
        var panel = Oskari.clazz.create('Oskari.catalogue.bundle.metadataflyout.view.MetadataPanel', me.instance, me.locale, model);
        if (me.asyncTabs && !jQuery.isEmptyObject(me.asyncTabs)) {
          panel.addTabs(me.asyncTabs);
        }
        me.addPanel(panel);
        panel.init(i === 0);
      }
    }
  },
  addTabsAsync: function addTabsAsync(data) {
    var me = this;
    if (me.panels && me.panels.length) {
      me.panels.forEach(function (panel) {
        return panel.addTabsAsync(data);
      });
    } else {
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          me.asyncTabs[key] = data[key];
        }
      }
    }
  },
  /**
   * @private @method _processJSON
   *
   * @param {Object} metadataJSON Metadata object
   *
   */
  _processJSON: function _processJSON(metadataJson) {
    var me = this,
      data,
      dataTemplate,
      i,
      identificationTemplate;
    // underscore templates don't like missing values, so let's extend empty strings and arrays...
    dataTemplate = {
      lineageStatements: [],
      dataQualities: [],
      distributionFormats: [],
      fileIdentifier: '',
      identifications: [],
      metadataCharacterSet: '',
      metadataDateStamp: '',
      metadataLanguage: '',
      metadataOrganisationNames: [],
      metadataStandardName: '',
      metadataStandardVersion: '',
      onlineResources: [],
      scopeCodes: []
    };
    identificationTemplate = {
      abstractText: '',
      accessConstraints: [],
      browseGraphics: [],
      citation: {
        date: {
          date: '',
          dateType: ''
        },
        resourceIdentifiers: [],
        title: ''
      },
      classifications: [],
      descriptiveKeywords: [],
      languages: [],
      operatesOn: [],
      otherConstraints: [],
      responsibleParties: [],
      serviceType: '',
      spatialRepresentationTypes: [],
      spatialResolutions: [],
      temporalExtents: [],
      topicCategories: [],
      useLimitations: []
    };
    data = Oskari.util.deepClone(dataTemplate, metadataJson);
    data.lineageStatements.forEach(function (lineage, index) {
      data.lineageStatements[index] = me._prettify(lineage);
    });
    data.dataQualities.forEach(function (dataQuality) {
      dataQuality.UIlabel = me.locale.heading[dataQuality.nodeName];
    });
    for (i = 0; i < data.identifications.length; i += 1) {
      data.identifications[i] = Oskari.util.deepClone(identificationTemplate, data.identifications[i]);
    }
    data.identifications.forEach(function (identification) {
      // Split abstract text to paragraphs and make links into anchors
      identification.abstractText = me._prettify(identification.abstractText);
      if (!identification.browseGraphics) {
        identification.browseGraphics = [];
      }
      if (!identification.citation) {
        identification.citation = {};
      }
      if (identification.citation.title === undefined) {
        identification.citation.title = '';
      }
      if (!identification.otherConstraints) {
        identification.otherConstraints = [];
      }
      for (i = 0; i < identification.otherConstraints.length; i += 1) {
        identification.otherConstraints[i] = me._prettify(identification.otherConstraints[i]);
      }
      if (!identification.useLimitations) {
        identification.useLimitations = [];
      }
      for (i = 0; i < identification.useLimitations.length; i += 1) {
        identification.useLimitations[i] = me._prettify(identification.useLimitations[i]);
      }
    });
    me._createContent(data);
  },
  /**
   * @private @method _prettify
   * Chops the text into paragraphs, makes links into anchors.
   *
   * @param {string} text Text
   *
   */
  _prettify: function _prettify(text) {
    var me = this,
      ret = [];
    if (text) {
      text.split('\n').forEach(function (paragraph) {
        ret.push(me._linkify(paragraph.trim()));
      });
    }
    return ret;
  },
  /**
   * @private @method _getMetadata
   * This is the actual data loader function
   *
   * @param {string} uuid UUID
   * @param {number} layerId layer id
   *
   */
  _getMetadata: function _getMetadata(uuid, layerId) {
    var me = this;
    if ((uuid === null || uuid === undefined) && (layerId === null || layerId === undefined)) {
      throw new TypeError('_getMetadata(): missing uuid and layerId');
    }
    me.instance.getLoader().getCSWData(uuid, layerId, Oskari.getLang(),
    // TODO add sensible error handling
    function (data) {
      me._processJSON(data);
    }, function (jqXHR, exception) {
      // Request failed, show generic message to user
      me._showMetadataNotFoundMessage();
    });
    return true;
  },
  /**
   * @method showMetadata
   *
   * Launches Ajax requests to embed metadata descriptions
   * for requested metadata
   *
   * Backend provides HTML setups that will be embedded and
   * styled with bundled CSS.
   *
   * @param {string} uuid uuid
   * @param {number} layerId layer id
   *
   */
  showMetadata: function showMetadata(uuid, layerId) {
    if ((uuid === null || uuid === undefined) && (layerId === null || layerId === undefined)) {
      // Not a major error, keep on rolling
      this.instance.getSandbox().printError('showMetadata(): Missing layerId and uuid.');
      return;
    }
    this._getMetadata(uuid, layerId);
  },
  /**
   * @method scheduleShowMetadata
   *
   * this 'schedules' asyncronous loading
   * ( calls directly now )
   * Used to buffer excess calls. Main entry point.
   *
   * @param {number} layerId layer id
   *
   */
  scheduleShowMetadata: function scheduleShowMetadata(uuid, layerId) {
    if ((uuid === null || uuid === undefined) && (layerId === null || layerId === undefined)) {
      // Not a major error, keep on rolling
      this.instance.getSandbox().printError('scheduleShowMetadata(): Missing uuid and layerId.');
      return;
    }
    this.showMetadata(uuid, layerId);
  },
  /**
   * @private @method _linkify
   * FIXME use the original linkify if possible?
   * slightly modified  http://code.google.com/p/jquery-linkify/
   *
   * @param {string} inputText
   *
   */
  _linkify: function _linkify(inputText) {
    var replacePattern, replacedText;

    // URLs starting with http://, https://, or ftp://
    replacePattern = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern, '<a href="$1" target="_blank">$1</a>');

    // URLs starting with www.
    // (without // before it, or it'd re-link the ones done above)
    replacePattern = /(^|[^/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern, '$1<a href="http://$2" target="_blank">$2</a>');

    // Change email addresses to mailto:: links
    // replacePattern = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
    // replacedText = replacedText.replace(
    //    replacePattern,
    //    '<a href="mailto:$1">$1</a>'
    // );

    return replacedText;
  },
  /**
   * @method showErrorMessage
   * Render 'metadata not found' message to ui
   */
  _showMetadataNotFoundMessage: function _showMetadataNotFoundMessage() {
    this.ui.text(this.locale.notFound);
  }
}, {
  extend: ['Oskari.userinterface.component.Accordion']
});